import {jobTimeToMinutes} from './job-schedule-format'

export type JobScheduleValidationInput = {
    startDate: Date | null
    endDate?: Date | null
    startTime?: string | null
    endTime?: string | null
    requireStartDate?: boolean
}

export function validateJobScheduleInput(
    input: JobScheduleValidationInput,
    fieldPrefix = '',
): Record<string, string> {
    const prefix = fieldPrefix ? `${fieldPrefix}.` : ''
    const errors: Record<string, string> = {}

    if (input.requireStartDate !== false && !input.startDate) {
        errors[`${prefix}startDate`] = 'Start date is required'
    }

    if (input.endDate && input.startDate && input.endDate < input.startDate) {
        errors[`${prefix}endDate`] = 'End date must be on or after start date'
    }

    if (input.endTime && !input.endDate) {
        errors[`${prefix}endTime`] = 'End time requires an end date'
    }

    if (input.endTime && !input.startTime) {
        errors[`${prefix}endTime`] = 'End time requires a start time'
    }

    if (
        input.endDate &&
        input.startDate &&
        input.endTime &&
        input.startTime &&
        input.endDate.toDateString() === input.startDate.toDateString()
    ) {
        const startMinutes = jobTimeToMinutes(input.startTime)
        const endMinutes = jobTimeToMinutes(input.endTime)
        if (startMinutes != null && endMinutes != null && endMinutes < startMinutes) {
            errors[`${prefix}endTime`] = 'End time must be on or after start time on the same day'
        }
    }

    return errors
}
